const initialState = {
  selectedCustomFields: []
};

const customFieldsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SELECT_RETAILER_CUSTOM_FIELDS':
      return {
        ...state,
        selectedCustomFields: action.payload
      };
    default:
      return state;
  }
};

export default customFieldsReducer;
